import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class OfferDetailsOperationsResponse {
  @jsonMember readonly canUpdate!: boolean;
  @jsonMember readonly canDelete!: boolean;
  @jsonMember readonly canView!: boolean;
  @jsonMember readonly canSharePreview!: boolean;
}
